import styled from 'styled-components';

export const MessageContainer = styled.div`
  color: ${(props) => props.color};
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
`;

export const TextDiv = styled.div`
  display: flex;
  align-items: center;
  box-sizing: border-box;
`;

export const Text = styled.p<{ padding?: string }>`
  font-size: 15px;
  padding: ${(props) => props.padding ?? '0 10px'};
  margin: 0;
`;
